<template>
  <el-button class="button" v-bind="$attrs" v-on="$listeners">
    <slot />
  </el-button>
</template>

<script>
export default {
  name: 'Button',
  props: {},
  data() {
    return {}
  },
  components: {},
  watch: {},
  computed: {},
  async mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.button {
  &.el-button {
    height: val(62);
    background: linear-gradient(
      0deg,
      rgba(55, 39, 57, 0.95),
      rgba(81, 70, 88, 0.95)
    );
    border: val(2) solid var(--button-border-color);
    border-radius: val(7);
    padding-top: 0px;
    padding-bottom: 0px;
    color: var(--dialog-color);
    font-size: val(26);
    &:active,
    &:focus {
      outline: none;
      border-color: var(--button-border-color);
    }
    &:active {
      opacity: 0.7;
    }
    & + .el-button {
      margin-left: val(100);
    }
  }
}
</style>
